module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/AlertTriangleGrey.c7939b39.svg";